export enum VideoSource {
  YT = 'YouTube',
  THM = 'TryHackMe',
}
